export default {
  getProjectOptions (projects) {
    const projectsOptions = []
    projectsOptions.push({ text: '-- Dowolny --', value: -1 })
    projects.forEach(function (project) {
      projectsOptions.push({ text: project.name, value: project.id })
    })
    return projectsOptions
  }
}
